import React, {ChangeEvent, useEffect, useRef, useState} from "react"
import {connect, useDispatch, useSelector} from "react-redux"
import {createData} from "../../action/action"
import {Lottie} from "@crello/react-lottie"
import Styles from "./display.less"
import loadingStep from "../../../static/pic/小K状态/检测状态/检测状态.json"
import large from "../../../static/pic/large.svg"
import restore from "../../../static/pic/restore.png"
import shrink from "../../../static/pic/shrink.svg"
import rotate1 from "../../../static/pic/rotate1.png"
import rotate2 from "../../../static/pic/rotate2.png"
import request from "../../../util/request"
import {v4} from "uuid"
const promiseType: {[name: string]: {size: number; valid: boolean}} = {
    pdf: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    jpg: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    jpeg: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    png: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
    ofd: {
        valid: true,
        size: 10 * 1024 * 1024,
    },
}
interface AllowType {
    [type: string]: {
        size: number
    }
}
const allowType: AllowType = {
    png: {
        size: 8 * 1024 * 1024,
    },
    jpg: {
        size: 8 * 1024 * 1024,
    },
    jpeg: {
        size: 8 * 1024 * 1024,
    },
    pdf: {
        size: 10 * 1024 * 1024,
    },
}
const Display = () => {
    const dispatch = useDispatch()
    const model = useSelector((state: any) => state.model)
    const status = useSelector((state: any) => state.status)
    return <div className={Styles.displayArea}>{status === "loading" ? <Loading /> : <DisplayImage />}</div>
}

const Loading = () => {
    return (
        <div className={Styles.loadingArea}>
            <div className={Styles.loading}>
                <Lottie
                    width="120px"
                    height="120px"
                    config={{animationData: loadingStep, loop: true, autoplay: true}}
                />
                <span>正在上传分类文件，请稍后...</span>
            </div>
        </div>
    )
}

const DisplayImage = () => {
    const dispatch = useDispatch()
    const claData = useSelector((state: any) => state.claData)
    const activeIndex = useSelector((state: any) => state.activeIndex)
    const activeImageId = useSelector((state: any) => state.activeImageId)
    const model = useSelector((state: any) => state.model)
    const [style, setStyle] = useState({
        deg: 0,
        scale: 1,
        top: 0,
        left: 0,
    })
    const [imagePath, setImagePath] = useState("#")
    const [mouseDownPos, setMouseDownPos] = useState({
        moveStart: false,
        x: 0,
        y: 0,
    })

    useEffect(() => {
        if (activeImageId === 0) {
            dispatch(createData(getUpdateData(claData.claFileInfos[activeIndex].imageId)))
        }
        setImagePath(claData.claFileInfos.find((item: any) => item.imageId === activeImageId)?.imagePath)
    }, [activeImageId])
    useEffect(() => {
        if (claData.claRecoginzeDatas.length > 0 && claData.claFileInfos.length > 0) {
            dispatch({
                type: "setActiveIndexAndImageId",
                payload: {
                    activeIndex: 0,
                    imageId: claData.claFileInfos[0].imageId,
                },
            })
            // dispatch(createData(getUpdateData(claData.claFileInfos[0].imageId)))
        }
    }, [claData])
    const getUpdateData = (imageId: string) => {
        if (activeImageId !== imageId) {
            const data = claData.claRecoginzeDatas.filter((item: any) => item.imageId === imageId)[0]
            if (data.status === "success") {
                if (data.templateId) {
                    const updateData = {
                        ocrData: {
                            ocrResult: {
                                status: "success",
                                templateName: claData.claRecoginzeDatas.filter(
                                    (item: any) => item.imageId === imageId
                                )[0].templateName,
                                recognitionArea: claData.claRecoginzeDatas.filter(
                                    (item: any) => item.imageId === imageId
                                )[0].result.recognitionArea,
                                table: claData.claRecoginzeDatas.filter((item: any) => item.imageId === imageId)[0]
                                    .result.table,
                                tableField: claData.claRecoginzeDatas.filter((item: any) => item.imageId === imageId)[0]
                                    .tableField,
                            },
                        },
                    }
                    return updateData
                } else {
                    model.invokeAsync("resultData", {
                        code: "0",
                        message: data.progress,
                    })
                    return {
                        ocrData: {
                            ocrResult: {
                                status: "noTemplate",
                                templateName: "",
                                recognitionArea: [],
                                table: [],
                                tableField: [],
                            },
                        },
                    }
                }
            } else if (data.status === "error") {
                model.invokeAsync("resultData", {
                    code: "0",
                    message: data.progress,
                })
                return {
                    ocrData: {
                        ocrResult: {
                            status: "error",
                            templateName: "",
                            recognitionArea: [],
                            table: [],
                            tableField: [],
                        },
                    },
                }
            }
        }
    }
    const pageTurn = (type: string) => {
        if (type === "befor" && activeIndex !== 0) {
            dispatch({
                type: "setActiveIndexAndImageId",
                payload: {
                    activeIndex: activeIndex - 1,
                    imageId: claData.claFileInfos[activeIndex - 1].imageId,
                },
            })
            dispatch(createData(getUpdateData(claData.claFileInfos[activeIndex - 1].imageId)))
        }
        if (type === "after" && activeIndex !== claData.claFileInfos.length - 1) {
            dispatch({
                type: "setActiveIndexAndImageId",
                payload: {
                    activeIndex: activeIndex + 1,
                    imageId: claData.claFileInfos[activeIndex + 1].imageId,
                },
            })
            dispatch(createData(getUpdateData(claData.claFileInfos[activeIndex + 1].imageId)))
        }
    }
    const inputRef = useRef<HTMLInputElement>(null)
    const uploadFileList = useSelector((state: any) => state.uploadFileList)
    const fileSizeMax = useSelector((state: any) => state.fileSizeMax)
    const viewType = useSelector((state: any) => state.viewType)
    const url = useSelector((state: any) => state.url)
    const uploadFile = () => {
        const fileList = inputRef.current?.files
        let count = 0
        let uploadList = []
        console.log(fileList)
        console.log(fileList && fileList.length > 0)
        if (fileList && fileList.length > 0) {
            for (let i = 0; i < fileList.length; i++) {
                const file: File = fileList[i]
                const type: string = file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase()
                if (!(type in allowType)) {
                    model.invokeAsync("resultData", {
                        code: "0",
                        message: "检测到不符合规范的文件类型。",
                    })
                    return
                }
                if (file.size > allowType[type].size) {
                    model.invokeAsync("resultData", {
                        code: "0",
                        message: "文件大小不符合规范。",
                    })
                    return
                }
                if (file && type in promiseType) {
                    if (promiseType[type] && count < fileSizeMax) {
                        count++
                        uploadList.push({file: file, type: type})
                    }
                }
            }
            Promise.all(uploadList.map((item) => toUrl(item.file, item.type))).then(
                (res) => {
                    console.log("qwe")
                    dispatch({type: "startTesting", payload: res})
                    model.invokeAsync(viewType, res)
                    dispatch({
                        type: "clearUploadFileList",
                        payload: [],
                    })
                },
                (err) => {
                    // model.invokeAsync("resultData", {
                    //     code: "0",
                    //     message: err,
                    // })
                }
            )
            // Promise.all(uploadList.map((item) => toLocal(item.file, item.type))).then(
            //     (res) => {
            //         dispatch({type: "startTesting", payload: res})
            //         model.invoke(viewType, res)
            //     },
            //     (err) => console.log(err)
            // )
        }
    }

    const toLocal = async (file: File, type: string) => {
        return new Promise((resolve, reject) => {
            console.log(uploadFileList)
            if (uploadFileList.length < fileSizeMax) {
                dispatch({
                    type: "uploadFile",
                    payload: {
                        fileName: file.name,
                        url: `res.url`,
                        status: "success",
                        fileType: type,
                    },
                })
                resolve({
                    fileName: file.name,
                    url: ` res.url`,
                    status: "success",
                    fileType: type,
                })
            }
        })
    }

    const toUrl = async (file: File, type: string) => {
        const form = new FormData()
        form.append("file", file)
        form.append("url", file.name)
        form.append("urlType", "pc")
        form.append("appId", "cvp")
        form.append("fId", "cvp_classifier")
        form.append("token", v4())
        return new Promise((resolve, reject) => {
            request(
                `${url}`,
                {
                    method: "POST",
                    body: form,
                },
                (res: any) => {
                    if (res.status === "success") {
                        if (uploadFileList.length < fileSizeMax) {
                            dispatch({
                                type: "uploadFile",
                                payload: {
                                    fileName: file.name,
                                    url: res.url,
                                    status: "success",
                                    fileType: type,
                                },
                            })
                            resolve({
                                fileName: file.name,
                                url: res.url,
                                status: "success",
                                fileType: type,
                                fileSize: file.size,
                            })
                        }
                    } else {
                        model.invokeAsync("resultData", {
                            code: "0",
                            message: res.description,
                        })
                        dispatch({
                            type: "clearUploadFileList",
                            payload: [],
                        })
                        reject("error")
                    }
                }
            )
        })
    }
    return (
        <div className={Styles.displayBox}>
            <div className={Styles.displayNav}>
                <input
                    ref={inputRef}
                    multiple
                    accept={".png,.jpg,.jpeg,.pdf"}
                    type="file"
                    onChange={(e) => uploadFile()}
                    style={{display: "none"}}
                />
                <div
                    onClick={() => {
                        setStyle({...style, scale: style.scale + 0.1 >= 2.0 ? 2.0 : style.scale + 0.1, top: 0, left: 0})
                    }}
                    className={Styles.DisplayBtnArea}
                >
                    <img className={Styles.zoom} src={large} />
                </div>
                <div
                    onClick={() => {
                        setStyle({...style, scale: style.scale - 0.1 <= 0.5 ? 0.5 : style.scale - 0.1, top: 0, left: 0})
                    }}
                    className={Styles.DisplayBtnArea}
                >
                    <img className={Styles.zoom} src={shrink} />
                </div>
                <div
                    onClick={() => {
                        setStyle({
                            deg: 0,
                            scale: 1,
                            top: 0,
                            left: 0,
                        })
                    }}
                    className={Styles.DisplayBtnArea}
                >
                    <img className={Styles.zoom} src={restore} />
                </div>
                <div
                    onClick={() => setStyle({...style, deg: style.deg - 90, top: 0, left: 0})}
                    className={Styles.DisplayBtnArea}
                >
                    <img className={Styles.rotate} src={rotate1} />
                </div>
                <div
                    onClick={() => setStyle({...style, deg: style.deg + 90, top: 0, left: 0})}
                    className={Styles.DisplayBtnArea}
                >
                    <img className={Styles.rotate} src={rotate2} />
                </div>
                <button onClick={() => inputRef.current?.click()} className={Styles.reupload}>
                    重新上传
                </button>
            </div>
            <div className={Styles.showImage}>
                <img
                    onMouseDown={(e) => {
                        setMouseDownPos({
                            moveStart: true,
                            x: e.clientX,
                            y: e.clientY,
                        })
                    }}
                    onMouseMove={(e) => {
                        if (mouseDownPos.moveStart) {
                            setStyle({
                                ...style,
                                top: e.clientY - mouseDownPos.y,
                                left: e.clientX - mouseDownPos.x,
                            })
                        }
                    }}
                    onMouseUp={() => {
                        setMouseDownPos({
                            moveStart: false,
                            x: 0,
                            y: 0,
                        })
                    }}
                    onMouseOut={() => {
                        setMouseDownPos({
                            moveStart: false,
                            x: 0,
                            y: 0,
                        })
                    }}
                    src={imagePath}
                    style={{
                        top: style.top,
                        left: style.left,
                        transform: `scale(${style.scale}) rotate(${style.deg}deg)`,
                    }}
                />
            </div>
            <div className={Styles.displayFooter}>
                <button onClick={() => pageTurn("befor")}>上一页</button>
                <span className={Styles.activePageNum}>{`${activeIndex + 1}`}</span>
                <span>/</span>
                <span>{`${claData.claFileInfos.length}`}</span>
                <button onClick={() => pageTurn("after")}>下一页</button>
            </div>
        </div>
    )
}

export default Display
